/*jshint -W071, -W072, -W117, -W040*/
(function () {
    'use strict';

    angular
        .module('app.region')
        .controller('RegionDashboardController', regionDashboardController);
    
    /* @ngInject */
    function regionDashboardController(regionService, logger, currentUser, strategies) {
        this.$onInit = onInit;

        var vm = this;

        vm.model = {};
        vm.mode = {};

        vm.reset = {
            invokeRegions: undefined,
            invokeAreas: undefined,
            invokeStates: undefined
        };

        vm.selectedCorporate = null;
        vm.corporates = [];

        vm.PermissionStrategies = strategies();

        vm.onModeChange = onModeChange;
        vm.onModeChanged = onModeChanged;
        vm.onRegionChanged = onRegionChanged;
        vm.onAreaChanged = onAreaChanged;
        vm.onTotalSiteCountUpdated = onTotalSiteCountUpdated;
        vm.onStateAdded = onStateAdded;
        vm.onStateRemoved = onStateRemoved;
        vm.onStateWithSitesAdded = onStateWithSitesAdded;
        vm.onStateWithSitesRemoved = onStateWithSitesRemoved;
        vm.onSiteAdded = onSiteAdded;
        vm.onSiteRemoved = onSiteRemoved;
        vm.onSiteCountChange = onSiteCountChange;

        vm.changeToCreate = changeToCreate;
        vm.onClear = onClear;
        vm.onReset = onReset;
        vm.updateSelectedCorporate = updateSelectedCorporate;

        function onInit() {
            vm.mode = regionService.getDefaultModeModel();
            getCorporates();
            logger.info('Activated Region Management View');
        }

        function getCorporates() {
            if (currentUser.isInRole('SSO:SysAdmin')) {
                regionService.getCorporates().then(function (result) {
                    if (result) {
                        vm.corporates = result;
                        vm.selectedCorporate = vm.corporates[0];
                        resetModel(vm.mode);
                    } else {
                        vm.corporates = [];
                        vm.selectedCorporate = null;
                    }
                });
            } else {
                if (!!currentUser.userSettings) {
                    regionService.getCorporate(currentUser.userSettings.CorporateCustomerId).then(function (result) {
                        if (result) {
                            vm.corporates = result;
                            vm.selectedCorporate = vm.corporates[0];
                            resetModel(vm.mode);
                        } else {
                            vm.corporates = [];
                            vm.selectedCorporate = null;
                        }
                    });
                }
            }
        }

        function onModeChange(mode) {
            vm.mode = mode;
            resetModel(vm.mode);
        }

        function onModeChanged(mode) {
            vm.mode = mode;
            vm.mode = angular.extend({}, vm.mode);
        }

        function onRegionChanged(region) {
            vm.model = region;
            onModelChange();
        }

        function onAreaChanged(area) {
            vm.model = area;
            onModelChange();
        }

        function onStateAdded(state) {
            vm.model.states.push(state);
            onModelChange();
        }

        function onTotalSiteCountUpdated(count) {
            vm.model.totalSites = count;
            onModelChange();
        }

        function onStateRemoved(index) {
            if (index !== -1) {
                vm.model.states.splice(index, 1);
                onModelChange();   
            }
        }

        function onStateWithSitesAdded(state) {
            vm.model.states.push(state);
            vm.model.selectedSites = vm.model.selectedSites + state.sites.length;
            onModelChange();
        }

        function onStateWithSitesRemoved(index) {
            if (index !== -1) {
                vm.model.selectedSites = vm.model.selectedSites - vm.model.states[index].sites.length;
                vm.model.states.splice(index, 1);
                onModelChange();
            }   
        }

        function onSiteCountChange(count) {
            vm.model.totalSites = count;
            onModelChange();
        }

        function onSiteAdded(stateIndex, state) {
            if (stateIndex !== -1) {
                vm.model.states[stateIndex].sites.push(state);
                vm.model.selectedSites++;
                onModelChange();
            }
        }
        
        function onSiteRemoved(stateIndex, siteIndex) {
            if (stateIndex !== -1 && siteIndex !== -1) {
                vm.model.states[stateIndex].sites.splice(siteIndex, 1);
                vm.model.selectedSites--;
                onModelChange();
            }
        }

        function onModelChange() {
            vm.model = angular.extend({}, vm.model);
        }

        function onClear() {
            resetModel(vm.mode);
        }

        function onReset() {
            resetModel(vm.mode);
        }

        function changeToCreate() {
            vm.mode.isCreate = true;
            vm.mode.isEdit = false;
            resetModel(vm.mode);
        }

        function updateSelectedCorporate() {
            resetModel(vm.mode);
        }

        function resetModel(mode) {
            if (mode.isRegion) {
                vm.model = regionService.getDefaultRegionModel();
                vm.model.corporateid = vm.selectedCorporate.id;
            } else {
                vm.model = regionService.getDefaultAreaModel();
                vm.model.corporateid = vm.selectedCorporate.id;
            }
        }
    }
})();
